import React, { memo } from "react";
import useStyles from "./styles";
import ImagesConfig from "components/ImagesConfig";

import { Images } from "config/images";
import { Grid } from "@material-ui/core";

const PromotionItem = memo(props => {
	const classes = useStyles();
	const { group } = props;

	return (
		<Grid style={{ marginTop: 10 }}>
			<Grid classes={{ root: classes.root }}>
				<Grid classes={{ root: classes.customImage }}>
					<ImagesConfig
						image={group.products[0]?.image}
						width={58}
						height={58}
						imageDefault={Images.icProductDefault}
					/>
					<Grid classes={{ root: classes.name }}>
						{group.products[0]?.name}
					</Grid>
				</Grid>
				<Grid classes={{ root: classes.quantity }}>
					<Grid style={{ marginLeft: 10 }}>x{group?.quantity}</Grid>{" "}
					<Grid>Lẻ</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
});

export default PromotionItem;
